import axios from 'axios'

const RequestService = {
  async get (params = {}) {
    return axios.get('po/purchase-order/requests', { params })
  },

  async histories (params = {}) {
    return axios.get('po/reports/purchase-order/request-histories', { params })
  },

  async show (id) {
    return axios.get(`po/purchase-order/requests/${id}`)
  },

  async post (params = {}) {
    return axios.post('po/purchase-order/requests', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`po/purchase-order/requests/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`po/purchase-order/requests/${data.id}`, { data })
  }
}

export default RequestService
